import { render, staticRenderFns } from "./filter-sidebar.vue?vue&type=template&id=5b707430&scoped=true&"
import script from "./filter-sidebar.vue?vue&type=script&lang=ts&"
export * from "./filter-sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./filter-sidebar.vue?vue&type=style&index=0&id=5b707430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b707430",
  null
  
)

export default component.exports